var app = angular.module("nms.links", []);

app.config(["$translatePartialLoaderProvider", function($translatePartialLoader) {
    $translatePartialLoader.addPart("features/topology/links");
}]);

app.run(["$translate", function($translate) {
        $translate.refresh();
    }
]);
